let config = {
  production: {
    ENV: "production",
    IS_PRODUCTION: true,
    IMAGE_BASE_URL: "/assets/img/",
    DATA_BASE_URL: "https://adminapi.yugcontract.ua/",
    AUTH_BASE_URL: "https://auth.yugcontract.ua/api/",
    CHECKOUT_BASE_URL: "https://checkout.yugcontract.ua/",
    RECAPTCHA_SITE_KEY: "6LeFpVYdAAAAAEkuPYWCLWJiRvcMZhdnDI08zGZH",
  },
  development: {
    ENV: "development",
    IS_PRODUCTION: false,
    IMAGE_BASE_URL: "/assets/img/",
    DATA_BASE_URL: "https://dev.adminapi.yugcontract.ua/",
    AUTH_BASE_URL: "https://auth.yugcontract.ua/api/",
    // AUTH_BASE_URL: "http://dev.yugcontract.ua:3400/api/",
    CHECKOUT_BASE_URL: "https://checkout.yugcontract.ua/",
    RECAPTCHA_SITE_KEY: "6LeFpVYdAAAAAEkuPYWCLWJiRvcMZhdnDI08zGZH",
  }
};


module.exports = config[process.env.NODE_ENV];
